import React, { useState } from 'react'
import { collection, addDoc, setDoc, doc } from 'firebase/firestore'
import { Form, Button, Alert } from 'react-bootstrap'
import { useInput } from '../../hooks/useInput'
import { db } from '../../firebase'

export default function UploadInfo() {
    const [State, setState] = useInput();
    const [msg, setMsg] = useState()
    const addIntro = async(e)=>{
        e.preventDefault()
        setMsg("")
        const introRef = doc(db, "introField", "intro")
        await setDoc(introRef, {intro: State})
        setMsg("Upload Successful")
    }
    
    const addAbout = async(e)=>{
        e.preventDefault()
        setMsg("")
        const about1Ref = doc(db, "about", "about1")
        await setDoc(about1Ref, {about1: State})
        setMsg("Upload Successful")
    }

    const addskills = async(e)=>{
        e.preventDefault()
        setMsg("")
        const skill = doc(db, "skillset", "skills");
        await setDoc(skill, {skills: State})
        setMsg("Upload Successful")
    }

  return (
    <>
        <h2 className='pt-5'>Upload Info</h2>
        {msg && <Alert variant='success'>{msg}</Alert>}
        <Form className='mb-4' onSubmit={addIntro}>
            <Form.Label>Add Intro</Form.Label>
            <Form.Control as={"textarea"} className="mb-3" onChange={setState}></Form.Control>
            <Button type='submit'>Upload</Button>
        </Form>

        <Form className='mb-4' onSubmit={addAbout}>
            <Form.Label>Add About</Form.Label>
            <Form.Control as={"textarea"} className="mb-3" onChange={setState}></Form.Control>
            <Button type='submit'>Upload</Button>
        </Form>

        <Form className='mb-4' onSubmit={addskills}>
            <Form.Label>Add Skills</Form.Label>
            <Form.Control as={"textarea"} className="mb-3" onChange={setState}></Form.Control>
            <Button type='submit'>Upload</Button>
        </Form>

    </>
  )
}
